import { FETCH_JOKL_ORDERS, CLEAN_JOKL_ORDERS, SET_JOKL_ORDER_PAID, SET_JOKL_ORDER_PROCESSED, DELETE_JOKL_ORDER } from '../actions/types';
import _ from 'lodash';
import { toNumber } from '../functions';

const JOKL_ORDERS_DEFAULT_STATE = {};

const JoklOrdersReducer = (state = JOKL_ORDERS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_JOKL_ORDERS:
            return payload;

        case SET_JOKL_ORDER_PAID:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, status: 'paid' };
                }

                return item;
            }) };

        case SET_JOKL_ORDER_PROCESSED:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, status: 'processed' };
                }

                return item;
            }) };

        case CLEAN_JOKL_ORDERS:
        case DELETE_JOKL_ORDER:
            return JOKL_ORDERS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default JoklOrdersReducer;
